










































































// Vue
import { Vue, Component } from 'vue-property-decorator'

// components
import { Select2, DatePicker } from '@/components/form'
import { Loading } from '@/components'

// models
import { DeviceModel } from '@/models/config'
import { PropOptionSelect } from '@/models'

// services
import { DeviceService } from '@/services/config'
import ZKLibService from '@/services/zklib/zklibService'

// utils
import { loading, alerts } from '@/utils'
import { AssistanceDeviceZk } from '@/models/assistance'
import { AssistanceService } from '@/services/assistance'

@Component({
    name: 'FormGetFromDevice',
    components: {
        Select2,
        DatePicker,
        Loading
    }
})
export default class FormGetFromDevice extends Vue {
    devices: DeviceModel[] = []
    devicesSelected: number|null = null
    isLoading = false
    date_start: null|string = null
    date_end: null|string = null

    created () {
        this.getDevices()
    }

    async getDevices () {
        this.isLoading = true
        this.devices = await DeviceService.getAllActivedAndConnected()
        this.isLoading = false
    }

    async processAssists (deviceSelected: DeviceModel, assistance: AssistanceDeviceZk[]) {
        loading('show')
        AssistanceService.importAssistsFromDevice(deviceSelected.id, assistance).then(res => {
            this.$emit('success-import-from-device', {
                assists: res,
                deviceId: this.devicesSelected
            })
        }).catch(() => {
            alerts.error('Error al intentar procesar asistencias del dispositivo')
        }).finally(() => {
            loading('hide')
        })
    }

    async filterAssistance () {
        const date_start = this.date_start ? new Date(this.date_start) : null
        const date_end = this.date_end ? new Date(this.date_end) : null
        if (!this.date_start || !this.date_end || (!date_start || !date_end || date_start > date_end)) {
            return alerts.error('Debe completar los campo de fechas, y la fecha inicial debe ser menor o igual a la fecha final')
        }
        if (this.devicesSelected) {
            loading('show')
            // get assitance of the device selected
            const device = this.devices.find(d => d.id === this.devicesSelected)
            if (device) {
                ZKLibService.getAssistancesByDate(String(device.ip), Number(device?.port), this.date_start, this.date_end).then(response => {
                    const assistValid: AssistanceDeviceZk[] = response.data.map(assistance => {
                        return {
                            uid: assistance.uid,
                            user_id: Number(assistance.user_id),
                            date: assistance.date,
                            time: assistance.time
                        }
                    })
                    this.processAssists(device, assistValid)
                }).catch(() => {
                    alerts.error('Error al intentar conectar con el dispositivo')
                }).finally(() => {
                    loading('hide')
                })
            } else {
                loading('hide')
                return alerts.error('Debe seleccionar un dispositvo')
            }
        } else {
            return alerts.error('Debe seleccionar un dispositvo')
        }
    }

    get opDevices (): PropOptionSelect[] {
        return this.devices.map(device => {
            return {
                value: device.id,
                text: device.name
            }
        })
    }
}
